/**
 * The computed longhands the properties panel shows for a selected box, reported by the bridge on
 * `box.css` and on every mark confirm. Longhands only: a computed SHORTHAND (`padding`, `border-radius`)
 * serializes differently across engines. One list, interpolated into the bridge and read by the host, so
 * the reporter and the reader cannot drift. Its own module so the host never has to import the bridge.
 */
export const BOX_CSS_PROPS = [
  'width', 'height', 'min-height', 'box-sizing', 'left', 'top', 'z-index',
  'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'row-gap', 'column-gap',
  'flex-direction', 'justify-content', 'align-items', 'align-self', 'background-color',
  'border-top-left-radius', 'border-top-right-radius', 'border-bottom-right-radius', 'border-bottom-left-radius',
  'border-top-width', 'border-top-style', 'border-top-color', 'opacity', 'object-fit', 'position',
] as const

export type BoxCssProp = (typeof BOX_CSS_PROPS)[number]
